//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { library } from '@fortawesome/fontawesome-svg-core';
import { faHandHoldingHeart } from '@fortawesome/pro-regular-svg-icons';
import { mapGetters, mapState } from 'vuex';
import PageLoader from '@motionelements/core/src/components/ui/PageLoader.vue';
import SectionHeader from '@/components/landing/SectionHeader.vue';
import HeroAsideWrapper from '@/components/landing/HeroAsideWrapper.vue';
import DynamicElements from '@/components/landing/dlp/DynamicElements.vue';
import LightboxElements from '@/components/landing/dlp/LightboxElements.vue';

library.add(faHandHoldingHeart);

const MAX_OBSERVER_SETUP_RETRIES = 10;

export default {
  name: 'LandingDynamicLandingPage',
  components: {
    SectionHeader,
    HeroAsideWrapper,
    PageLoader,
    DynamicElements,
    PageMeta: () => import('@motionelements/core/src/components/ThePageMeta.vue'),
    Breadcrumbs: () => import('@motionelements/core/src/components/ui/BaseBreadcrumbs.vue'),
    Lightbox: LightboxElements,
  },
  props: {
    isLoaded: { type: Boolean, default: false },
  },
  data() {
    return {
      scrollLoadObserver: null,
    };
  },
  computed: {
    ...mapState({
      typeaheadKeywords: state => _.get(state, 'search.typeahead.keywords', []),
    }),
    ...mapGetters({
      dlpData: 'dlp/dlpData',
      backgroundImageUrl: 'dlp/backgroundImageUrl',
      keywords: 'dlp/keywords',
      heading: 'dlp/heading',
      subheading: 'dlp/subheading',
      description: 'dlp/description',
      lightboxes: 'dlp/lightboxes',
      mediaTypes: 'dlp/mediaTypes',
      dlpSections: 'dlp/dlpSections',
    }),
    keywordsParam() {
      const k = this.keywords;
      if (Array.isArray(k)) {
        return k.length ? k.join(',') : '';
      }
      return k || '';
    },
    mediaType() {
      return this.mediaTypes && this.mediaTypes[0];
    },
    sidebarDescription() {
      let raw = _.get(this.dlpData, 'description');
      if (raw == null || (typeof raw === 'string' && !raw.trim())) {
        raw = _.get(this.dlpData, 'html.description');
      }
      if (raw == null) return '';
      const trimmed = typeof raw === 'string' ? raw.trim() : String(raw).trim();
      if (!trimmed) return '';
      const sub = String(this.subheading || '').trim();
      const plain = trimmed.replace(/<[^>]+>/g, '').replace(/\s+/g, ' ').trim();
      if (sub && plain === sub) return '';
      return trimmed;
    },
    sidebarDescriptionNl2br() {
      const desc = this.sidebarDescription;
      if (!desc) return '';
      return _.escape(desc).replace(/\r?\n/g, '<br>');
    },
    breadcrumbList() {
      const list = [];
      if (this.mediaType) {
        list.push({
          name: this.$term('mediaType', this.mediaType).text(),
          link: this.$link(this.$tools.getChannelUrl(this.mediaType)).url(),
        });
        const category = _.get(this.dlpData, 'category');
        if (category && _.get(category, 'name')) {
          list.push({
            name: category.name,
            link: this.$link(category.url).url(),
          });
        }
        list.push({
          name: this.heading,
          link: _.get(this.dlpData, 'url', this.$route.path),
        });
      }
      return list;
    },
    backgroundImageObject() {
      if (this.backgroundImageUrl) {
        return {
          previews: { jpg: { url: this.backgroundImageUrl } },
        };
      }
      if (this.lightboxes && this.lightboxes.length) {
        const element = _.get(this.lightboxes, '[0].items.data[0]');
        if (element) {
          const imageUrl = _.get(element, 'previews.jpg.url');
          const url = _.get(element, 'html.url');
          if (imageUrl) {
            return {
              name: _.get(element, 'name') || '',
              url: url ? this.$link(url).url() : null,
              artist: { username: _.get(element, 'artist.username') },
              previews: { jpg: { url: imageUrl } },
            };
          }
        }
      }
      return null;
    },
  },
  watch: {
    mediaTypes: {
      handler(types) {
        if (process.client && types && types.length) {
          this.$nextTick(() => this.setupScrollLoadObserver());
        }
      },
      immediate: true,
    },
  },
  beforeDestroy() {
    if (this.scrollLoadObserver) {
      this.scrollLoadObserver.disconnect();
      this.scrollLoadObserver = null;
    }
  },
  methods: {
    viewAllSearchUrl(mediaType) {
      return this.$link(`/search/${mediaType}`)
        .param('s', this.keywordsParam)
        .param('discovery_page', _.get(this.dlpData, 'id'))
        .url();
    },
    loadSectionAndScroll(mediaType) {
      this.$store.dispatch('dlp/loadDlpSection', mediaType);
      this.$nextTick(() => {
        const el = document.getElementById(`dynamic-elements-${mediaType}`);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    },
    setupScrollLoadObserver(retryCount) {
      if (typeof document === 'undefined' || typeof IntersectionObserver === 'undefined') {
        return;
      }
      if (this.scrollLoadObserver) {
        this.scrollLoadObserver.disconnect();
        this.scrollLoadObserver = null;
      }
      const sectionEls = document.querySelectorAll('[id^="dynamic-elements-"]');
      if (!sectionEls.length) {
        const count = retryCount || 0;
        if (count < MAX_OBSERVER_SETUP_RETRIES) {
          this.$nextTick(() => this.setupScrollLoadObserver(count + 1));
        }
        return;
      }
      this.scrollLoadObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) {
              return;
            }
            const id = entry.target.id;
            const mediaType = id.replace(/^dynamic-elements-/, '');
            if (mediaType) {
              this.scrollLoadObserver.unobserve(entry.target);
              this.$store.dispatch('dlp/loadDlpSection', mediaType);
            }
          });
        },
        { rootMargin: '100px 0px', threshold: 0 },
      );
      sectionEls.forEach((el) => this.scrollLoadObserver.observe(el));
    },
  },
};
